/** Kept in sync with backend/services/canvas_write_contract.py. */
export const USER_CANVAS_METADATA_KEYS = new Set(`
entered_canvas_at last_activity_at aspect_ratio wh_ratio generation_group_id
output_index source_label skip_style_analysis lineage_source_node_ids
lineage_relation_type lineage_relation_label template_instance director_board
is_empty source_duration source_start source_end rotation flip_h flip_v color_adj
background layers artboard viewport_transform foreground_mask_url transcript
group_id group_child_ids group_collapsed group_label workflow_area_group_id
decomposition_parent_id element_index text_overlays sticker_overlays smart_edit_history
prompt_metadata storyboard grid_panel_edit_data chain_pending preparing_created_at
text variant sequence_data reference_evidence
`.trim().split(/\s+/));

const CREATION_ONLY_METADATA_KEYS = new Set(['is_empty', 'chain_pending', 'preparing_created_at']);

export function userCanvasMetadata(
  metadata: Record<string, unknown>, allowCreationState = true,
): Record<string, unknown> {
  return Object.fromEntries(Object.entries(metadata).filter(([key]) =>
    USER_CANVAS_METADATA_KEYS.has(key) && (allowCreationState || !CREATION_ONLY_METADATA_KEYS.has(key)),
  ));
}

/** Ordinary edits have no authority over persisted media or task projection fields. */
export function userCanvasUpdate(input: Record<string, unknown>): Record<string, unknown> {
  const { asset_id, video_url, thumbnail_url, media_type, ...editable } = input;
  if (editable.metadata && typeof editable.metadata === 'object') {
    return { ...editable, metadata: userCanvasMetadata(editable.metadata as Record<string, unknown>, false) };
  }
  return editable;
}

const revisions = new Map<string, number>();
export function rememberCanvasBindingRevision(row: { id: string; media_binding_revision?: number }): void {
  const value = row.media_binding_revision;
  if (typeof value === 'number' && Number.isSafeInteger(value) && value >= 0) {
    revisions.set(row.id, Math.max(revisions.get(row.id) ?? 0, value));
  }
}
export function getCanvasBindingRevision(nodeId: string): number | undefined {
  return revisions.get(nodeId);
}
